import {Injectable} from '@angular/core';
import {BookingStoreService} from "../booking/booking-store.service";
import {Vaps} from "./vaps";
import {EMPTY, Observable} from "rxjs";
import {ApiService} from "../../core/services/api.service";
import {tap} from "rxjs/operators";

@Injectable()
export class VapsService {
  constructor(private bookingStore: BookingStoreService, private apiService: ApiService) {
  }

  get vaps() {
    const selectedVaps = this.bookingStore.getMyBooking()?.booking?.vaps ?? [];
    return this.bookingStore.getVaps()
      .map(v => {
        v.selected = selectedVaps.some(uuid => uuid === v.uuid);
        return v;
      });
  }

  toggle(vaps: Vaps): Observable<any> {
    if (this.apiService.bookingChangeInProgress) {
      return EMPTY;
    }

    const key = this.bookingStore.get()?.key;

    if (vaps.selected) {
      return this.apiService.postBookingChange(`workshopinfo/v1/my-booking/${key}/remove-vaps/${vaps.uuid}`)
        .pipe(tap(myBooking => this.bookingStore.set(myBooking)));
    }

    return this.apiService.postBookingChange(`workshopinfo/v1/my-booking/${key}/add-vaps/${vaps.uuid}`)
      .pipe(tap(myBooking => this.bookingStore.set(myBooking)));
  }
}
